import { useCallback } from 'react';
import { useSearchParams } from 'react-router';

const DEFAULT_PAGE = 1;
const DEFAULT_PAGE_SIZE = 10;

type Options = {
  defaultPageSize?: number;
};

export const useUrlPagination = ({ defaultPageSize = DEFAULT_PAGE_SIZE }: Options = {}) => {
  const [searchParams, setSearchParams] = useSearchParams();

  const page = Number(searchParams.get('page') ?? DEFAULT_PAGE);
  const pageSize = Number(searchParams.get('pageSize') ?? defaultPageSize);

  const onPaginationChange = useCallback(
    (nextPage: number, nextPageSize: number) => {
      setSearchParams(
        (prev) => {
          const next = new URLSearchParams(prev);
          next.set('page', String(nextPage));
          next.set('pageSize', String(nextPageSize));
          return next;
        },
        { replace: false }
      );
    },
    [setSearchParams]
  );

  return { page, pageSize, onPaginationChange };
};
